import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
// import { Typography } from '@material-ui/core';
class Footer extends Component {
  state = {};

  render() {
    const { classes } = this.props;
    return (
      <footer className={classes.root}>
        {/* <Typography>Main layout footer section</Typography> */}
      </footer>
    );
  }
}

export default withStyles(Footer);